<template>
  <figure>
    <img v-lazy="imageSrc" :alt="appName"/>
  </figure>
</template>

<script>
export default {
  props: {
    images: Object,
    ua: String,
    appName: String
  },
  computed: {
    imageSrc () {
      const imgSrc = '/static/img/common/spacer.gif'
      let url = ''

      if (this.ua === 'pc') {
        if (!this.images.material_1x1_350) return imgSrc
        url = this.images.material_1x1_350.url
      } else {
        if (!this.images.material_1x1_250) return imgSrc
        url = this.images.material_1x1_250.url
      }
      return url
    }
  }
}
</script>
